import { Component, Input, OnInit } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-badge',
    templateUrl: './badge.component.html',
    styleUrls: ['./badge.component.scss'],
    standalone: true,
    imports: [NgIf]
})
export class BadgeComponent implements OnInit {
  @Input() badgeType = '';
  @Input() addMarginLeft = false;
  @Input() showText = true;

  label = '';
  bgColor = '';

  constructor() { }

  ngOnInit(): void {
  }

  handleIcon(): string {
    if (this.badgeType === 'agente-top') {
      this.label = this.badgeType.replace('agente-', '');
      return 'icon-crown';
    }

    if (this.badgeType === 'top') {
      this.label = 'top';
      return 'icon-star';
    }

    if (this.badgeType === 'super top') {
      this.label = 'super top';
      return 'icon-gem';
    }
    return;
  }

  handleBgColor(): string {
    if (this.badgeType === 'agente-top') {
      return '#8CC63F';
    }

    if (this.badgeType === 'top') {
      return '#F23091';
    }

    if (this.badgeType === 'super top') {
      return '#a117e5';
    }
    return '';
  }
}

